import styled, { css } from 'styled-components';
import theme from '../../assets/styles/theme';

const getContainerHeightBasedOnVariant = (variant) => {
  if (variant === 'home') return '300px';
  if (variant === 'dashboard') return '476px';
};

export const Carousel = styled.div`
  height: ${(props) => getContainerHeightBasedOnVariant(props.variant)};
  width: 328px;
  position: relative;
  overflow: hidden;
  @media (max-width: 1365px) {
    width: 456px;
    height: 340px;
  }
`;

export const CarouselImagesWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;

const getImageHeightBasedOnVariant = (variant) => {
  if (variant === 'home') return '300px';
  if (variant === 'dashboard') return '448px';
};

export const CarouselImage = styled.div`
  height: ${(props) => getImageHeightBasedOnVariant(props.variant)};
  min-width: 328px;
  transition: 0.3s ease all;
  position: relative;
  img {
    border-radius: ${theme.borderRadius[`border-radius-4`]};
    height: 100%;
    width: 100%;
    object-fit: inherit;
  }
  @media (max-width: 1366px) {
    min-width: 456px;
    height: 340px;
  }
`;

const getBottomHeightBasedOnVariant = (variant) => {
  if (variant === 'home')
    return css`
      position: absolute;
      align-items: flex-end;
    `;
  if (variant === 'dashboard')
    return css`
      padding: ${theme.spacing[`spacing-3`]} ${theme.spacing[`spacing-6`]};
      position: absolute;
      bottom: 0;
    `;
};

export const CarouselBottom = styled.div`
  ${(props) => getBottomHeightBasedOnVariant(props.variant)};
  display: flex;
  width: 100%;
  height: 28px;
  justify-content: center;
  align-content: center;
  top: 260px;
  @media (max-width: 1366px) {
    top: 300px;
  }
`;

const getOvalVariant = (variant) => {
  if (variant === 'neutral')
    return css`
      border-color: ${theme.colors.primary.border.transparent};
      background-color: ${theme.colors.neutral.bg.strong};
    `;
  if (variant === 'primary')
    return css`
      border-color: ${theme.colors.neutral.border.transparent};
      background-color: ${theme.colors.primary.bg.selected};
    `;
};
export const Oval = styled.div`
  ${(props) => getOvalVariant(props.variant)}
  width: 10px;
  height: 10px;
  margin-right: ${theme.spacing[`spacing-3`]};
  border-radius: ${theme.borderRadius[`border-radius-5`]};
  border-width: 1px;
  border-style: solid;
  cursor: pointer;
`;
